import React from "react";
import Pagination from "semantic-ui-react/dist/commonjs/addons/Pagination";

import { Link } from "../../lib/Link";
import { Transportation } from "./Transportation";
import { Tags } from "./Tags";
import { VacantFloorJou } from "./VacantFloorJou";
import { VacantFloorJouNew } from "./VacantFloorJouNew";
import classnames from "classnames";
import masterData from "../../lib/masterData";
import _ from 'lodash';
import { getAssetUrl } from "../../lib/masterUtil";
import criteo from "../../lib/criteo";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { isBetsukanriInHokkaido } from "../../lib/isBetsukanriInHokkaido"

export class ResultList extends React.Component {
  state = { activePage: 1, sortType: 'vacant' };
  itemsPerPage = 20;
  onPageChange(value) {
    this.setState({ activePage: value.activePage });
    this.props.resetScroll("list");
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      activePage: 1,
    });
  }
  setSortType(sortType) {
    this.setState({ sortType });
  }
  render() {
    const { list,type } = this.props;
    if (!list) {
      return <div />;
    }
    const page = {
      activePage: this.state.activePage,
      boundaryRange: 1,
      siblingRange: 1,
      showEllipsis: true,
      showFirstAndLastNav: true,
      showPreviousAndNextNav: true,
      totalPages: Math.ceil(list.length / this.itemsPerPage),
    };
    const startIndex = (this.state.activePage - 1) * this.itemsPerPage;
    let sortValue1 = null;
    let sortValue2 = null;
    let pageList = null;
    if (!this.state.sortType) {
      sortValue1 = asset => asset.chumokuBkn;
      sortValue2 = asset => asset.assetId;
      pageList = list.slice(0)
        .sort((a, b) => {
          let s = sortValue1(b) - sortValue1(a);
          if (s == 0) {
            sortValue2(b) - sortValue2(a);
          } else {
            return s;
          }
        })
        .slice(startIndex, startIndex + this.itemsPerPage);
    } else {
      if (this.state.sortType === "price") {
        sortValue1 = asset => asset.min_price;
      } else if (this.state.sortType === "station") {
        sortValue1 = asset => asset.min_station_distance;
      } else if (this.state.sortType === "vacant") {
        sortValue1 = asset => asset.vacantStatus;
      }
      pageList = list.slice(0)
        .sort((a, b) => {
          return sortValue1(a) - sortValue1(b);
        })
        .slice(startIndex, startIndex + this.itemsPerPage);
    }

    const listDigestForCriteo = pageList.slice(0, 3).map((asset) => asset.assetId);
    criteo.sendEvent({ event: "viewList", item: listDigestForCriteo })

    return (
      <div className="result_list">
        <div className="data_header">
          <div className="count">{list && list.length}</div>
          <div className="collection">
            <div
              className={classnames("item link", {
                active: this.state.sortType === "vacant",
              })}
              onClick={() => this.setSortType("vacant")}
            >
              空室順
            </div>
            <div
              className={classnames("item link", {
                active: this.state.sortType === "price",
              })}
              onClick={() => this.setSortType("price")}
            >
              賃料順
            </div>
            <div
              className={classnames("item link", {
                active: this.state.sortType === "station",
              })}
              onClick={() => this.setSortType("station")}
            >
              駅近順
            </div>
            <div
              className={classnames("item link", {
                active: this.state.sortType == null,
              })}
              onClick={() => this.setSortType(null)}
            >
              指定なし
            </div>
          </div>
        </div>
        <div className="data_content">
          {pageList.map((asset, index) => {
            //const campaign = masterData.campaign.byId[asset.primaryCampaign || asset.campaigns && asset.campaigns[0]];
            const campaign = masterData.campaign.byId[asset.primaryCampaignVacant];
            const assetIcon = masterData.assetIcon.bySlug[asset.assetIcon];
            let url = getAssetUrl(asset);
            return (
            <div className={classnames("item", asset.chumokuBkn && "attention")}>
              <Link
                to={url}
                key={index}
              >
                <div className={classnames("link")}>
                  <div className="title">
                    <span className="type">
                      <div>
                        <img src={assetIcon && assetIcon.icon}/>
                      </div>
                      {/* <span>{assetIcon.name}</span> */}
                    </span>
                    <span className={classnames("titleText", !asset.chumokuBkn && "noattention")}><h3>{asset.name}</h3></span>
                  </div>
                  {/* <div className="price">
                    {asset.min_price && asset.min_price.toLocaleString()}
                    /月～
                    {asset.max_price && asset.max_price.toLocaleString()}
                    円/月 {asset.min_extent}～{asset.max_extent}帖
                  </div> */}
                  {campaign && (
                    <div className="campaign">{campaign.campaignName}</div>
                  )}
                  <div className="address">{asset.addressNavi == null ? asset.address : asset.addressNavi}</div>
                  {type === TYPE_PC && (
                  <Transportation stationInfos={asset.stations} single={true} />
                  )}
                  <Tags tags={asset.tags} />
                </div>
              </Link>
              {!isBetsukanriInHokkaido(asset) && <VacantFloorJouNew floors={asset.vacantFloorJou} tags={asset.tags} vacantStatus={asset.vacantStatus} />}
            </div>
          )})}
        </div>
        <div className="page_cont">
          <Pagination
            activePage={page.activePage}
            boundaryRange={page.boundaryRange}
            onPageChange={(event, value) => {
              this.onPageChange(value);
            }}
            size="mini"
            siblingRange={page.siblingRange}
            totalPages={page.totalPages}
            // Heads up! All items are powered by shorthands, if you want to hide one of them, just pass `null` as value
            ellipsisItem={page.showEllipsis ? undefined : null}
            firstItem={page.showFirstAndLastNav ? undefined : null}
            lastItem={page.showFirstAndLastNav ? undefined : null}
            prevItem={page.showPreviousAndNextNav ? undefined : null}
            nextItem={page.showPreviousAndNextNav ? undefined : null}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/ResultList.jsx